import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import isLoyaltyCalculationRequestWithBonus from 'loyalty/lib/pointsCalculation/isLoyaltyCalculationRequestWithBonus'

type Payload = paths['/api/lux-loyalty/points/calculate-earn']['post']['requestBody']['content']['application/json']
type Response = paths['/api/lux-loyalty/points/calculate-earn']['post']['responses']['200']['content']['application/json']

export interface EarnPointsCalculationOptions {
  customerId: string
  currency: string
  luxPlusMember: boolean
}

export function mapProductDetails(request: App.LoyaltyPointsEarnCalculationRequest): Payload['productDetails'] {
  if (isLoyaltyCalculationRequestWithBonus(request)) {
    return {
      loyaltyProductType: request.loyaltyProductType,
      offerId: request.offerId,
      packageId: request.packageId,
      earnKey: request.earnKey,
      promoKey: request.promoKey,
    }
  }

  return {
    loyaltyProductType: request.loyaltyProductType,
    earnKey: request.earnKey,
    promoKey: request.promoKey,
  }
}

export function mapRequestToPayload(request: App.LoyaltyPointsEarnCalculationRequest, options: EarnPointsCalculationOptions): Payload {
  return {
    publicPrice: request.price,
    luxPlusPrice: request.memberPrice,
    luxPlusMember: options.luxPlusMember,
    currency: options.currency,
    mx: request.mx,
    customerId: options.customerId,
    productDetails: mapProductDetails(request),
  }
}

export function mapResponseToCalculation(request: App.LoyaltyPointsEarnCalculationRequest, result: Response['result']): App.LoyaltyPointsEarnCalculation {
  const basePoints = result.totalBasePoints
  const bonusPoints = result.totalBonusPoints
  const bonusStatusCredits = result.totalBonusStatusCredits
  const statusCredits = result.totalStatusCredits
  const appliedRuleIds = result.appliedCustomRuleIds

  return {
    request,
    points: basePoints + bonusPoints,
    basePoints,
    bonusPoints,
    bonusStatusCredits,
    statusCredits,
    appliedRuleIds,
    roundingEnabled: result.roundingEnabled,
    roundedPointsEarnRatio: result.totalPointsEarnRatio,
  }
}
